export const environment = {
  production: true,
  mockEnable: false,

  bff_token_session_url:'https://apiqa.digital.interbank.pe/security/v1/oauth/token',
  bff_token_sessionapi_ver: 'v1',
  bff_token_session_auth:'d2lzdGx2b3RoYXBydUZybzpQTzFqMG5QWXZoWUJxOW9K',
  bff_token_session_key: 'a64eee4dedba4be180381a6ca5b99036',

  bff_token_avi_url:'https://apiqa.digital.interbank.pe/api/external-payment-gateway/v1/avi-payments/get-data',
  bff_token_avi_api_ver: 'v1',
  bff_token_avi_sub_key:'a64eee4dedba4be180381a6ca5b99036',

  bff_transger_avi_url:'https://apiqa.digital.interbank.pe/api/external-payment-gateway/v1/avi-payments/transfer',
  bff_transger_avi_api_ver: 'v1',
  bff_transger_avi_sub_key:'a64eee4dedba4be180381a6ca5b99036',

  cdn: 'https://web-qa.digital.interbank.pe',
  iframeUrl: 'https://sandbox-checkout.izipay.pe/payments/v1/js/index.js',
  newRelic: {
    licenseKey: 'NRBR-214f0d14584c61e00d2',
    applicationID: '601572184',
    accountID: '3272475',
    trustKey: '2487962',
    agentID: '601572184',
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    environment: 'development',
    appVersion: '1.0.0'
  }
};